import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const QRCodeMap = [
  { code: 'F4jG8kP3rT6yU9iQ2wS5xV7bM1n', redirectTo: '/7pX9qR2tK5wY8vZ3sN6cB4mH1dL' }, // Capítulo 1
  { code: 'a5D9hJ2kL7mN3pQ6sR8tV4wX1z', redirectTo: '/3bC6dF9gH2jK5mN8pQ1rS4tV7y' }, // Capítulo 2
  { code: 'Z4xW7vU9tS2rQ5pO8nM1kL6jH3', redirectTo: '/8yT3rE5wQ9uI2oP7aS1dF4gH6j' }, // Capítulo 3
  { code: 'k6L9mN2bV5cX8zZ1qW4eR7tY3', redirectTo: '/2sD5fG8hJ1kL4mN7pQ0rT3uV6' }, // Capítulo 4
  { code: '9wE4rT7yU1iO5pA8sD2fG6hJ3', redirectTo: '/Q3mN6bV9cX1zZ4wE7rT2yU5i8' }, // Capítulo 5
  { code: 'Q3mN6bV9cX1zZ4wE7rT2yU5i8', redirectTo: '/6pX9qR2tK5wY8vZ3sN6cB4mH1dL' }, // Capítulo 6
  { code: 'L5mN9bV2cX8zZ4wE7rT1yU3i6', redirectTo: '/5tR8uY2iP4oA7sD1fG6hJ9kL3' }, // Capítulo 7
  { code: 'M3nV6bX9cZ1zW4wE7rT2yU5i8', redirectTo: '/H4jK7mN1bV3cX6zZ9wE2rT5y' }, // Capítulo 8
  { code: 'N7bV2cX9zZ4wE1rT5yU3i6mL8', redirectTo: '/6gH9jK2lM5nP8qS1vW4xY7zZ3' }, // Capítulo 9
  { code: 'O9cX1zZ4wE7rT2yU5i8mL6bV3', redirectTo: '/3dF6gH1jK4lM7nP0qS2vW5xY8' }, // Capítulo 10
  { code: 'J7vK2pX5sQ9zR4tW8yU3iH6mN1bV', redirectTo: '/7vW2xY5zZ8aB1cD4eF6gH9jK3' }, // Capítulo 11
  { code: 'T4cF7gY1hJ5kL9mP2qS6vX8zZ3w', redirectTo: '/4nP7qS2vW5xY8zZ1aB3cD6eF9gH' }, // Capítulo 12
  { code: 'R1zZ4wE7rT2yU5i8mL6bV3nX9', redirectTo: '/8kL3mN6bV9cX2zZ5wE1rT4yU7i' }, // Capítulo 13
  { code: 'qB9wE4rT7yU2iO5pA8sD3fG6jH1kL', redirectTo: '/zX5cV8bN2mK9jL6hG3dF7gS1aQ4wE' }, // Capítulo 14
  { code: 'book', redirectTo: '/?book'}, //Bool cover
  { code: 'event', redirectTo: '/special-event', expires: '2023-01-01' }, // Expired
  { code: 'future', redirectTo: '/', expires: '2025-12-31' }, // Valid
  // Add more mappings as needed
];

export default function QRRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // 'checking' | 'valid' | 'expired' | 'invalid'

  useEffect(() => {
    const redirectData = QRCodeMap.find(item => item.code === code);

    if (!redirectData) {
      setStatus('invalid');
      return;
    }

    if (redirectData.expires) {
      const expirationDate = new Date(redirectData.expires);
      const currentDate = new Date();
      
      if (currentDate > expirationDate) {
        setStatus('expired');
        return;
      }
    }

    // Valid redirect
    navigate(redirectData.redirectTo, { replace: true });
    setStatus('valid');

  }, [code, navigate]);

  if (status === 'checking') {
    return (
      <div className="container text-center mt-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Verifying QR code...</p>
      </div>
    );
  }

  if (status === 'invalid') {
    return (
      <div className="container text-center mt-5">
        <h2 className="text-danger">Invalid Code</h2>
        <p>The code "<strong>{code}</strong>" doesn't exist in our system</p>
        <a href="/" className="btn btn-primary mt-3">
          Return to Homepage
        </a>
      </div>
    );
  }

  if (status === 'expired') {
    return (
      <div className="container text-center mt-5">
        <h2 className="text-warning">Expired Code</h2>
        <p>The code "<strong>{code}</strong>" has expired</p>
        <div className="mt-4">
          <a href="/" className="btn btn-primary me-2">
            Home
          </a>
          <a href="/contact" className="btn btn-outline-secondary">
            Contact Support
          </a>
        </div>
      </div>
    );
  }

  // For valid codes, the redirect will happen before this renders
  return null;
}